import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Popover } from '@televet/kibble-ui/build/components/Popover';
import { useHistory } from 'react-router-dom';
import { IPopoverContentType } from '.';

interface IDisabledPopoverProps {
  popoverType: IPopoverContentType | void;
  children: React.ReactNode;
}

export const TextMessagePopover = ({ popoverType, children }: IDisabledPopoverProps): JSX.Element => {
  const history = useHistory();

  if (!popoverType) return <>{children}</>;
  return (
    <Popover
      placement="end-end"
      trigger="hover"
      headerProps={{
        children: 'Text Messaging Unavailable',
      }}
      anchor={
        <Flex align="center" cursor="pointer">
          {children}
        </Flex>
      }
    >
      {popoverType === IPopoverContentType.Text_Messaging_unavailable && (
        <>
          <Text variant="onContrast" size="sm">
            A dedicated number has not been configured for your clinic. Add a dedicated number in
          </Text>{' '}
          <Text
            size="sm"
            variant="interactiveOnContrast"
            onClick={(): void => history.push('/settings/clinic/phone')}
            cursor="pointer"
          >
            Settings
          </Text>
          .
        </>
      )}
      {popoverType === IPopoverContentType.Delivery_Option_Unavailable && (
        <Text size="sm" variant="onContrast">
          You must add a Reminder before Text Message can be selected{' '}
        </Text>
      )}
    </Popover>
  );
};
